import styled from '@emotion/styled';
// Theme 타입을 받아오는 함수 정의 (선택적, 테마 사용 방식에 따라 조정)
const getThemeProp = (prop)=>(props)=>props.theme[prop];
// MobileNavigation 제거 - layout.styles.ts의 MobileNavigation을 대신 사용
// 중복 컴포넌트로 인한 export 충돌 해결
// --- 모바일 오른쪽 사이드바 스타일 --- 
export const MobileRightSidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 모바일 하단 네비게이션(z-index: ~100) 및 기타 요소 위로 배치 */
  z-index: 1000;
  visibility: ${({ $isOpen })=>$isOpen ? 'visible' : 'hidden'};
  transition: visibility 0.3s ease;
  overflow: hidden;
  
  @media (min-width: ${({ theme })=>theme.breakpoints.sm}) {
    display: none;
  }
`;
export const MobileRightSidebarBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${({ $isOpen })=>$isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
`;
export const MobileRightSidebarPanel = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0; /* 전체 폭 차지 */
  bottom: 0;
  /* 모바일에서는 전체 화면을 차지해야 함 */
  width: 100%;
  max-width: none;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  transform: ${({ $isOpen })=>$isOpen ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  
  /* VSCode 다크모드에서 배경색 설정 */
  .vscode-dark & {
    background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
  }
`;
